<template>
  <card :class="{ invalid: submitItemValid && allItemInvalid }">
    <div class="box__title">
      <div>물품종류</div>
      <div class="item-tooltip">
        <div>물품종류 안내</div>
        <img class="item__img" src="@/assets/img/order/qmark.svg" />
        <tooltip class="tooltip" type="deliveryItem" />
      </div>
    </div>
    <itemBox />
    <div v-if="stepStatus >= 5 || isWeightBoxOpen">
      <div class="box__title">무게 총합</div>
      <weightBox
        @calculator="$emit('calculator')"
        :loadingStatus="loadingStatus"
      />
    </div>
  </card>
</template>
<script>
import itemBox from "./item.vue";
import weightBox from "./weight.vue";
import card from "@/components/common/card.vue";
import tooltip from "@/components/common/tooltip.vue";
import mixinOrder from "@/mixins/mixinOrder";
import mixinOrderValidate from "@/mixins/mixinOrderValidate";
export default {
  mixins: [mixinOrder, mixinOrderValidate],
  props: ["loadingStatus", "stepStatus", "submitItemValid", "allItemInvalid"],
  components: { itemBox, weightBox, card, tooltip },
  data() {
    return {
      isWeightBoxOpen: false,
    };
  },
  watch: {
    "getDeliveryOptions.item": {
      handler(val) {
        this.isWeightBoxOpen = this.checkItemvalidate();
      },
      deep: true,
    },
  },
};
</script>
<style src="./layout.css" scoped />
<style src="@/assets/css/newGlobal.css" scoped></style>
